var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ChunkedRequester_instances, _ChunkedRequester_requests, _ChunkedRequester_delay, _ChunkedRequester_limit, _ChunkedRequester_timeout, _ChunkedRequester_startRequests;
import axios from "axios";
class ChunkedRequester {
    constructor(limit = 16, delay = 500) {
        _ChunkedRequester_instances.add(this);
        _ChunkedRequester_requests.set(this, []);
        _ChunkedRequester_delay.set(this, void 0);
        _ChunkedRequester_limit.set(this, void 0);
        _ChunkedRequester_timeout.set(this, null);
        if (limit < 1) {
            throw new Error('Limit must be positive');
        }
        __classPrivateFieldSet(this, _ChunkedRequester_limit, limit, "f");
        __classPrivateFieldSet(this, _ChunkedRequester_delay, delay, "f");
    }
    addRequest(url, parameters = {}) {
        return new Promise((resolve, reject) => {
            __classPrivateFieldGet(this, _ChunkedRequester_requests, "f").push({
                url,
                parameters,
                resolve,
                reject
            });
            __classPrivateFieldGet(this, _ChunkedRequester_instances, "m", _ChunkedRequester_startRequests).call(this);
        });
    }
    clearTimeout() {
        clearTimeout(__classPrivateFieldGet(this, _ChunkedRequester_timeout, "f"));
        __classPrivateFieldSet(this, _ChunkedRequester_timeout, null, "f");
    }
}
_ChunkedRequester_requests = new WeakMap(), _ChunkedRequester_delay = new WeakMap(), _ChunkedRequester_limit = new WeakMap(), _ChunkedRequester_timeout = new WeakMap(), _ChunkedRequester_instances = new WeakSet(), _ChunkedRequester_startRequests = function _ChunkedRequester_startRequests() {
    if (__classPrivateFieldGet(this, _ChunkedRequester_requests, "f").length === 0) {
        return;
    }
    if (__classPrivateFieldGet(this, _ChunkedRequester_requests, "f").length < __classPrivateFieldGet(this, _ChunkedRequester_limit, "f")) {
        this.clearTimeout();
    }
    if (__classPrivateFieldGet(this, _ChunkedRequester_timeout, "f") !== null) {
        return;
    }
    __classPrivateFieldSet(this, _ChunkedRequester_timeout, setTimeout(() => {
        Promise.all(__classPrivateFieldGet(this, _ChunkedRequester_requests, "f")
            .splice(0, __classPrivateFieldGet(this, _ChunkedRequester_limit, "f"))
            .map(({ url, parameters, resolve, reject }) => {
            return axios.get(url, { params: parameters }).then(resolve, reject);
        })).then(() => {
            this.clearTimeout();
            __classPrivateFieldGet(this, _ChunkedRequester_instances, "m", _ChunkedRequester_startRequests).call(this);
        });
    }, __classPrivateFieldGet(this, _ChunkedRequester_delay, "f")), "f");
};
export default ChunkedRequester;
